import { useEffect, useState } from "react";

const clamp = (v: number, mn: number, mx: number) => Math.max(mn, Math.min(mx, v));

/** Thin reading-progress bar. Owns its scroll listener so scrolling never re-renders the app shell. */
export function ScrollBar() {
  const [width, setWidth] = useState(0);

  useEffect(() => {
    const onScroll = () => {
      const total = Math.max(1, document.documentElement.scrollHeight - window.innerHeight);
      setWidth(clamp((window.scrollY / total) * 100, 0, 100));
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
    };
  }, []);

  return (
    <div className="fixed top-0 left-0 right-0 z-[100] h-0.5" aria-hidden="true">
      <div
        style={{
          width: `${width}%`,
          background: "#0ea5e9",
          height: "100%",
          transition: "width 0.1s linear",
        }}
      />
    </div>
  );
}
